import { GALLERY_CONSTS } from "pro-gallery";
import { GalleryOptions_Layout_Type as GALLERY_LAYOUT } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const isHorizontalLayout = ({ layout }) => {
  return layout && ([
    GALLERY_LAYOUT.THUMBNAIL,
    GALLERY_LAYOUT.SLIDER,
    GALLERY_LAYOUT.SLIDESHOW,
    GALLERY_LAYOUT.COLUMN,
    GALLERY_LAYOUT.FULLSIZE
  ].includes(layout.type) || layout.horizontalScroll);
};
const sampleItems = [1, 2, 3].map((i) => {
  return {
    metaData: {
      height: 10,
      width: 10
    },
    itemId: "sampleItem-" + i,
    mediaUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII="
    //eslint-disable-line
  };
});
const GALLERY_LAYOUT_TO_NUMBER = {
  [GALLERY_LAYOUT.UNRECOGNIZED]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.GRID,
  [GALLERY_LAYOUT.GRID]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.GRID,
  [GALLERY_LAYOUT.MASONRY]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.MASONRY,
  [GALLERY_LAYOUT.COLLAGE]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.COLLAGE,
  [GALLERY_LAYOUT.THUMBNAIL]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.THUMBNAIL,
  [GALLERY_LAYOUT.SLIDER]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.SLIDER,
  [GALLERY_LAYOUT.SLIDESHOW]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.SLIDESHOW,
  [GALLERY_LAYOUT.PANORAMA]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.PANORAMA,
  [GALLERY_LAYOUT.COLUMN]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.COLUMN,
  [GALLERY_LAYOUT.MAGIC]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.MAGIC,
  [GALLERY_LAYOUT.FULLSIZE]: GALLERY_CONSTS.layoutParams_structure_galleryLayout.FULLSIZE
};
const SCROLL_DIRECTION_TO_NUMBER = {
  [GALLERY_CONSTS.layoutParams_structure_scrollDirection.VERTICAL]: 0,
  [GALLERY_CONSTS.layoutParams_structure_scrollDirection.HORIZONTAL]: 1
};
export {
  GALLERY_LAYOUT_TO_NUMBER,
  SCROLL_DIRECTION_TO_NUMBER,
  isHorizontalLayout,
  sampleItems
};
//# sourceMappingURL=utils.js.map
